/*global AmCharts, App */

Components.Energy.Manager.ProgressChart = function(container, loadDataLink, currencySymbol, mediumUnit, typeData) {
    /* private */
    var _chart;
    var zoomOut = function() {
        try {
            _chart.zoomOut();
        } catch (e) {
        }
    };
    var prepareDataForChart = function(rawData) {
        var chartData = [];
        for (var index in rawData) {
            var row = rawData[index];
            var record = {};
            if (row.powerConsumptionActive) {
                record.powerConsumptionActive = Math.round(row.powerConsumptionActive * 100) / 100;
            }
            if (row.consumption) {
                record.consumption = Math.round(row.consumption * 100) / 100;
            }
            if (row.prediction) {
                record.prediction = Math.round(row.prediction * 100) / 100;
            }
            record.date = new Date(row.timestamp * 1000);
            chartData.push(record);
        }
        if (chartData.length == 0) {
            _chart.clear();
        } else {
            _chart.dataSets[0].dataProvider = chartData;
            _chart.validateData();
        }
    };
    var loadData = function() {
        App.Ui.widgetBlock($(_chart.containerDiv));
        $.ajax({
            dataType: "json",
            url: loadDataLink,
            complete: function() {
                App.Ui.widgetBlock($(_chart.containerDiv), "stop");
            },
            success: function(result) {
                if (result === null || result.length === 0) {
                    App.Ui.flashMessage(App.Ui.messages.unavailableData, "info");
                } else {
                    if (result.typeOfInterval) {
                        if (result.typeOfInterval === "1-hour") {
                            _chart.categoryAxesSettings.minPeriod = "hh";
                        } else if (result.typeOfInterval === "15-min") {
                            _chart.categoryAxesSettings.minPeriod = "15mm";
                        } else if (result.typeOfInterval === "5-min") {
                            _chart.categoryAxesSettings.minPeriod = "5mm";
                        } else {
                            _chart.categoryAxesSettings.minPeriod = "1mm";
                        }
                    }
                    prepareDataForChart(result.records);
                }
            },
            error: function() {
                App.Ui.flashMessage(App.Ui.messages.unavailableData, "info");
            }
        });
    };
    var createChart = function() {
        _chart = new AmCharts.AmStockChart();
        _chart.colors = [App.Ui.getColors()[3]];
        _chart.pathToImages = "/dist/amcharts/images/";
        _chart.export = App.Charts.export;
        _chart.dataSets = [
            {
                categoryField: "date",
                fieldMappings: [
                    {
                        fromField: "powerConsumptionActive",
                        toField: "powerConsumptionActive"
                    },
                    {
                        fromField: "consumption",
                        toField: "consumption"
                    },
                    {
                        fromField: "prediction",
                        toField: "prediction"
                    }
                ]
            }
        ];

        var stockPanel = new AmCharts.StockPanel();
        stockPanel.autoMarginOffset = 50;
        stockPanel.recalculateToPercents = "never";
        stockPanel.usePrefixes = true;
        stockPanel.colors = _chart.colors;
        _chart.addPanel(stockPanel);

        var graphA = new AmCharts.StockGraph();
        graphA.id = "sg1";
        graphA.valueField = typeData;
        graphA.periodValue = "Sum";
        graphA.type = "column";
        graphA.fillAlphas = 0.9;
        graphA.columnWidth = 0.75;
        graphA.balloonText = typeData === "consumption" ? "Cena:<b>[[value]]</b>" + currencySymbol : "Spotřeba:<b>[[value]]</b>Wh";
        graphA.useDataSetColors = false;

        var graphB = Object.create(graphA);
        graphB.id = "sg2";
        graphB.valueField = "prediction";
        graphB.fillColors = _chart.colors[0];
        graphB.lineColor = _chart.colors[0];
        graphB.fillAlphas = 0.3;
        graphB.dashLength = 5;
        graphB.clustered = false;
        graphB.balloonText = typeData === "consumption" ? "Cena:<b>[[value]]</b>" + currencySymbol + " <br>(predikce)" : "Spotřeba:<b>[[value]]</b>Wh <br>(predikce)";

        stockPanel.addStockGraph(graphA);
        // stockPanel.addStockGraph(graphB);

        var panelsSettings = new AmCharts.PanelsSettings();
        panelsSettings.marginLeft = 80;
        _chart.panelsSettings = panelsSettings;

        var scrollbarSettings = new AmCharts.ChartScrollbarSettings();
        scrollbarSettings.graph = "sg1";
        scrollbarSettings.graphType = "step";
        scrollbarSettings.updateOnReleaseOnly = false;
        _chart.chartScrollbarSettings = scrollbarSettings;

        var cursorSettings = new AmCharts.ChartCursorSettings();
        cursorSettings.categoryBalloonEnabled = true;
        cursorSettings.categoryBalloonDateFormats = [
            {
                period: 'fff',
                format: 'JJ:NN:SS'
            },
            {
                period: 'ss',
                format: 'JJ:NN:SS'
            },
            {
                period: 'mm',
                format: 'JJ:NN DD.MM.YYYY'
            },
            {
                period: 'hh',
                format: 'JJ:NN DD.MM.YYYY'
            },
            {
                period: 'DD',
                format: 'JJ:NN DD.MM.YYYY'
            },
            {
                period: 'WW',
                format: 'DD.MM.YYYY'
            },
            {
                period: 'MM',
                format: 'DD.MM.YYYY'
            },
            {
                period: 'YYYY',
                format: 'MMMM YYYY'
            }
        ];
        cursorSettings.cursorAlpha = 0.05;
        cursorSettings.fullWidth = true;
        cursorSettings.valueBalloonsEnabled = true;
        cursorSettings.valueLineEnabled = true;
        cursorSettings.valueLineBalloonEnabled = true;
        cursorSettings.valueLineAlpha = 0.5;
        _chart.chartCursorSettings = cursorSettings;

        var categoryAxesSettings = new AmCharts.CategoryAxesSettings();
        categoryAxesSettings.groupToPeriods = ["1mm", "5mm", "15mm", "hh", "6hh", "12hh", "DD", "MM", "YYYY"];
        categoryAxesSettings.minPeriod = "1mm";
        categoryAxesSettings.maxSeries = 150;
        categoryAxesSettings.dateFormats = [
            {
                period: 'fff',
                format: 'JJ:NN:SS'
            },
            {
                period: 'ss',
                format: 'JJ:NN:SS'
            },
            {
                period: 'mm',
                format: 'JJ:NN'
            },
            {
                period: 'hh',
                format: 'JJ:NN'
            },
            {
                period: 'DD',
                format: 'DD.MM.'
            },
            {
                period: 'WW',
                format: 'DD.MM.'
            },
            {
                period: 'MM',
                format: 'DD.MM.'
            },
            {
                period: 'YYYY',
                format: 'MMMM YYYY'
            }
        ];
        _chart.categoryAxesSettings = categoryAxesSettings;

        var valueAxesSettings = new AmCharts.ValueAxesSettings();
        valueAxesSettings.inside = false;
        valueAxesSettings.unit = typeData === "consumption" ? currencySymbol : mediumUnit;
        _chart.valueAxesSettings = valueAxesSettings;

        _chart.addListener("dataUpdated", function() {
            setTimeout(zoomOut, 250);
        });

        _chart.write(container);
        loadData();
    };
    var zoomToHour = function() {
        zoomOut();
        var startDate = _chart.startDate;
        var endDate = new Date(startDate.getTime() + 1 * 60 * 60 * 1000);
        _chart.zoom(startDate, endDate);
        inactive();
        $("#" + container + "_zoomToHour").addClass("active");
    };
    var zoomToDay = function() {
        zoomOut();
        var startDate = _chart.startDate;
        var endDate = new Date(startDate.getTime() + 1 * 24 * 60 * 60 * 1000);
        _chart.zoom(startDate, endDate);
        inactive();
        $("#" + container + "_zoomToDay").addClass("active");
    };
    var zoomMax = function() {
        zoomOut();
        inactive();
        $("#" + container + "_zoomMax").addClass("active");
    };
    var inactive = function() {
        $("#" + container + "_zoomToHour").removeClass("active");
        $("#" + container + "_zoomToDay").removeClass("active");
        $("#" + container + "_zoomMax").removeClass("active");
    };
    /* public */
    /* contructor */
    createChart();
    $("#" + container + "_zoomToHour").click(zoomToHour);
    $("#" + container + "_zoomToDay").click(zoomToDay);
    $("#" + container + "_zoomMax").click(zoomMax);
};
